import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    approveChannel = new Subject();
    formLegalisirChannel = new Subject();
    formBPJSChannel = new Subject();
    formTASPENChannel = new Subject();
    formKP4Channel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.formLegalisirChannel.next({status: apiResponse.INITIAL})
        this.formBPJSChannel.next({status: apiResponse.INITIAL})
        this.formTASPENChannel.next({status: apiResponse.INITIAL})
        this.formKP4Channel.next({status: apiResponse.INITIAL})
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.approveChannel.next({status: apiResponse.INITIAL})
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs unsubscribed')
        }
    }

    fetchApprove = async (query) => {
        try {
            this.approveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchApprove(query).then((result) => {
                this.approveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approveChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Unsubscribed')
        }
    }

    fetchFormLegalisir = async (query, cancelToken) => {
        try {
            this.formLegalisirChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchFormLegalisir(query, cancelToken).then((result) => {
                this.formLegalisirChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.formLegalisirChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Unsubscribedd')
        }
    }

    fetchFormBPJS = async (query, cancelToken) => {
        try {
            this.formBPJSChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchFormBPJS(query, cancelToken).then((result) =>{
                this.formBPJSChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.formBPJSChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchFormTASPEN = async (query, cancelToken) => {
        try {
            this.formTASPENChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchFormTASPEN(query, cancelToken).then((result) =>{
                this.formTASPENChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.formTASPENChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchFormKP4 = async (query, cancelToken) => {
        try {
            this.formKP4Channel.next({ status: apiResponse.LOADING })
            await this.repository.fetchFormKP4(query, cancelToken).then((result) =>{
                this.formKP4Channel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.formKP4Channel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
}

export default IndexBloc